export default __webpack_public_path__ + "static/media/LL-Thumbnail.d1f8f28c.png";